const CUSTOMER_KEY_PREFIX = "amz_";
const CUSTOMER_KEY_DIGEST_LENGTH = 46;

/**
 * Toss customerKey 생성 규칙:
 * - 입력: user id
 * - 출력: amz_{sha256(userId)[:46]} (총 50자)
 */
export async function buildTossCustomerKey(userId: string | number): Promise<string> {
  const normalizedUserId = String(userId ?? "").trim();
  if (!normalizedUserId) {
    throw new Error("Invalid user id for Toss customerKey.");
  }

  const cryptoApi = globalThis.crypto;
  if (!cryptoApi?.subtle) {
    throw new Error("Web Crypto API is not available.");
  }

  const payload = new TextEncoder().encode(normalizedUserId);
  const digest = await cryptoApi.subtle.digest("SHA-256", payload);
  const digestHex = Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");

  return `${CUSTOMER_KEY_PREFIX}${digestHex.slice(0, CUSTOMER_KEY_DIGEST_LENGTH)}`;
}
